




























import {computed, defineComponent} from '@vue/composition-api';

export default defineComponent({
  name: 'StatisticsItem',
  props: {
    title: {type: String, required: true},
    value: {type: [Number, String], required: true},
    icon: {type: String, required: true},
    // unit: {type: String, required: true},
    color: {type: String}
  },
  setup(props) {
    const valueString = computed(() => {
      if (typeof props.value === 'number') {
        return props.value.toLocaleString();
      }
      return props.value;
    });
    return {valueString};
  }
});
